<template>
  <div>
    <BatchTable
      :orderInspectionCode="orderInspectionCode"
      :changeOrderCode="changeOrderCode"
      :disabled="disabled"
      @reload="$emit('reload')"
      isExpand
    />
  </div>
</template>
<script>
import BatchTable from '../batch-table'
export default {
  components: { BatchTable },
  props: {
    orderInspectionCode: String,
    changeOrderCode: String,
    disabled: { type: Boolean, default: false },
  },
}
</script>
